var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteDistance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_10048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.38415 22.181C9.38415 22.181 13.3322 18.5139 14.5221 17.1433C15.7026 15.7834 16.3267 14.1688 16.3267 12.4742C16.3267 8.64503 13.2114 5.52979 9.3823 5.52979C7.53321 5.52979 5.79496 6.24385 4.48789 7.54037C3.18062 8.83708 2.45274 10.5695 2.43819 12.4184C2.42505 14.0827 3.04136 15.7079 4.22054 17.1183C5.29539 18.4041 9.38415 22.181 9.38415 22.181ZM9.38223 8.64291C11.4947 8.64291 13.2135 10.3616 13.2135 12.4742C13.2135 14.5867 11.4947 16.3053 9.38223 16.3053C7.26971 16.3053 5.55105 14.5867 5.55105 12.4742C5.55105 10.3616 7.26971 8.64291 9.38223 8.64291Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0874 26.8091H13.8322C13.9039 27.13 13.9431 27.4631 13.9431 27.8052C13.9431 28.1474 13.9039 28.4805 13.8322 28.8013H21.0873C21.0155 28.4805 20.9764 28.1474 20.9764 27.8052C20.9765 27.463 21.0156 27.13 21.0874 26.8091Z",
    fill: "#2027A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4265 17.6207L32.5883 14.6848L34.4265 11.749H24.6594V23.3299C24.9436 23.2742 25.2369 23.2443 25.5371 23.2443C25.9172 23.2443 26.2863 23.2918 26.6395 23.3797V17.6207H34.4265Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93251 26.8091H0.426514V28.8013H4.93244C4.86066 28.4805 4.82155 28.1474 4.82155 27.8052C4.82161 27.463 4.86073 27.13 4.93251 26.8091Z",
    fill: "#2027A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9869 28.8013H34.4265V26.8091H29.9869C30.0587 27.13 30.0978 27.4631 30.0978 27.8052C30.0978 28.1474 30.0587 28.4804 29.9869 28.8013Z",
    fill: "#2027A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54321 12.4743C7.54321 13.4884 8.36818 14.3133 9.3822 14.3133C10.3962 14.3133 11.2213 13.4883 11.2213 12.4743C11.2213 11.4603 10.3962 10.6353 9.3822 10.6353C8.36818 10.6353 7.54321 11.4603 7.54321 12.4743Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7786 30.0542C12.017 29.2888 12.4004 27.6643 11.6349 26.4259C10.8695 25.1875 9.24501 24.8041 8.00661 25.5696C6.76821 26.335 6.3848 27.9595 7.15026 29.1979C7.91571 30.4363 9.54016 30.8197 10.7786 30.0542Z",
    fill: "#2027A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1309 28.2239C28.3637 26.7876 27.3881 25.4345 25.9518 25.2017C24.5155 24.9688 23.1624 25.9445 22.9295 27.3808C22.6967 28.8171 23.6723 30.1702 25.1086 30.403C26.5449 30.6359 27.898 29.6603 28.1309 28.2239Z",
    fill: "#2027A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_10048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.426514 0.984863)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteDistance);
export default __webpack_public_path__ + "static/media/RouteDistance.d3e2c4dc17d5d2971d0d394e0de70e14.svg";
export { ForwardRef as ReactComponent };